<template>
  <div class="produto_page">
    <v-toolbar height="auto" color="black">
      <div class="d-flex flex-column align-start justify-space-around cont">
        <img
          class="diageo"
          src="../img/logo.png"
          width="75"
          alt="Logo Diageo"
        />
        <p class="categoria">
          {{ garrafa.dsCategoria }}
          <span class="segmento">{{ garrafa.dsSegmento }}</span>
        </p>
        <p class="produto">{{ garrafa.dsGarrafa }}</p>
      </div>
      <div>
        <v-btn icon @click="this.handleBack">
          <img
            class="btnBack"
            src="../img/right-arrow.png"
            width="30"
            alt="Botão voltar"
          />
        </v-btn>
      </div>
    </v-toolbar>
    <v-row>
      <v-progress-circular
        indeterminate
        class="mx-auto mt-5"
        v-if="loading"
        color="#FF8723"
      ></v-progress-circular>
    </v-row>
    <section class="px-4 mt-4 pt-0">
      <v-row style="max-width:100vw">
        <v-col class="pr-0" style="max-width: 65vw" cols="8">
          <h1 class="subTitle">Ficha Técnica</h1>

          <p
            class="mb-7"
            style="display: inline-block; width: 55vw; margin-top: 8px !important; line-height: 1.4; white-space: pre-wrap;"
          >{{ garrafa.dsFichaTecnica }}</p>
          <v-row class="pb-2">
            <v-col class="py-0" cols="3">
              <div class="circle d-flex align-center justify-center">
                <img src="../img/whiskey.png" width="31" alt="Icone garrafa" />
              </div>
            </v-col>
            <v-col
              class="d-flex flex-column justify-center px-0 pt-0 pb-2"
              cols="9"
              style="font-size: .9rem; line-height: 1.2;"
            >
              <span style="font-weight: bold;">Litragem (ml)</span>
              <span>{{ garrafa.dsLitragem | filterLitragem }}</span>
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col class="py-0" cols="3">
              <div class="circle d-flex align-center justify-center">
                <img src="../img/dose.png" width="31" alt="Icone Dose" />
              </div>
            </v-col>
            <v-col
              class="d-flex flex-column justify-center px-0 pt-0 pb-2"
              cols="9"
              style="font-size: .9rem; line-height: 1.2;"
            >
              <span style="font-weight: bold;">Quantidade de doses</span>
              <span>{{ garrafa.dsLitragem | filterQtdeDoses }}</span>
            </v-col>
          </v-row>

          <v-row class="pb-0">
            <v-col class="py-0" cols="3">
              <div class="circle d-flex align-center justify-center">
                <img
                  src="../img/heat.png"
                  width="31"
                  alt="Icone teor alcoólico"
                />
              </div>
            </v-col>
            <v-col
              class="d-flex flex-column justify-center px-0 pt-0 pb-2"
              cols="9"
              style="font-size: .9rem; line-height: 1.2;"
            >
              <span style="font-weight: bold;">Teor alcoólico</span>
              <span>{{ garrafa.dsTeorAlc }}%</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="px-0 pt-1" cols="4">
          <img
            v-if="garrafa.idGarrafa != undefined"
            @error="changeImg($event)"
            :src="$drink_img_uri + '/garrafa/' + garrafa.idGarrafa + '.png'"
            style="height:65vh; object-fit: cover;"
          />
        </v-col>
      </v-row>
    </section>

    <v-row class="mt-6 d-flex justify-center" style="max-width: 100vw;">
      <span class="divider"></span>
    </v-row>

    <section class="listDrinks px-4 mt-6 ">
      <h1 class="subTitle">Doses/Drinks</h1>
      <v-col class="px-0">
        <card-produto
          v-for="x in garrafa.bebidas"
          :key="x.idProduto"
          :produto="x"
        ></card-produto>
      </v-col>
    </section>
  </div>
</template>
<style>
.slide-enter-active,
.slide-leave-active {
  transition: transform 4s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(50%);
}
</style>
<script>
import "../css/produto.css";
import CardProduto from "../components/CardProduto.vue";

export default {
  name: "produto",
  components: { CardProduto },
  data() {
    return {
      garrafa: {
        categoria: "Whisky",
        segmento: "Super Deluxe",
        produto: "Johnnie Walker Blue Label",
      },

      loading: false,
    };
  },
  created() {
    const idGarrafa = this.$route.params.idGarrafa;
    this.loading = true;
    fetch(this.$drink_uri + "/get-garrafa/" + idGarrafa,
    {headers: {
      'Authorization': `Bearer ${localStorage.tokenDrink}`
    },
      credentials: "include"})
      .then((response) => response.json())
      .then((data) => {
        this.garrafa = data[0];
        this.loading = false;
        this.$forceUpdate();
      });
  },
  methods: {
    changeImg(e) {
      e.target.src = require("../img/garrafa.png");
    },
    handleBack() {
      this.$router.back();
    },
    calc() {
      console.log("Calc");
    },
  },
};
</script>
